import React from "react";
import { RevealHeading, MagneticButton } from "./Motion";
import { Waveform } from "./Waveform";
import { Squiggle, Sparkle, BnGlyph } from "./Decorations";

export const AdRevenue = () => {
    return (
        <section className="relative py-24 lg:py-32 overflow-hidden">
            <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
                <div className="relative bg-ink-pill text-cream-100 rounded-[40px] lg:rounded-[56px] p-8 sm:p-12 lg:p-20 overflow-hidden">
                    {/* Decorative */}
                    <div className="absolute top-0 left-0 w-full h-full opacity-90 pointer-events-none">
                        <Waveform bars={80} color="#FF5B3E" height={140} className="absolute inset-0 opacity-25" playing={true}/>
                    </div>
                    <Squiggle color="#FFD23F" className="absolute top-10 right-12 w-24 opacity-70 animate-float-slow"/>
                    <Sparkle color="#FF4FA3" className="absolute bottom-10 left-12 w-10 h-10 opacity-80 animate-float-fast"/>
                    <BnGlyph glyph="টাকা" className="absolute -bottom-12 right-6 text-[200px] lg:text-[320px] leading-none font-bold opacity-[0.06] select-none" color="#FFD23F"/>

                    <div className="relative max-w-[820px]">
                        <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">The flip</p>
                        <RevealHeading as="h2" className="h-display text-[48px] sm:text-[72px] lg:text-[112px] leading-[0.95]">
                            Don't pay us. <span className="italic-display text-coral">Earn</span> with us.
                        </RevealHeading>
                        <p className="mt-8 text-[17px] sm:text-[19px] text-cream-100/80 leading-relaxed max-w-[640px]">
                            Run pre-roll audio ads inside your articles. We handle the ad-tech, you keep <span className="font-bold text-coral">70%</span> of the revenue. We take 30%. That's it. No setup fee.
                        </p>
                        <div className="mt-8 bg-white/5 border border-white/10 rounded-3xl p-6 lg:p-7 backdrop-blur-sm max-w-[640px]">
                            <p className="text-[14px] sm:text-[15px] text-cream-100/85 leading-relaxed">
                                <span className="italic-display text-cream-100">If 5% of Prothom Alo's 40M monthly readers listen, that's</span> <span className="font-display font-bold text-mint text-[28px] lg:text-[36px] align-middle">2M</span> <span className="italic-display text-cream-100">plays — and real ad revenue every month.</span>
                            </p>
                        </div>
                        <div className="mt-10 flex flex-col sm:flex-row gap-4">
                            <MagneticButton className="bg-coral hover:bg-coral-dark text-white rounded-full px-7 py-4 text-[15px] font-semibold inline-flex items-center gap-2 hover:shadow-coral transition-all">
                                Apply for revenue share →
                            </MagneticButton>
                            <button className="text-cream-100/80 hover:text-cream-100 transition-colors text-[14px] font-medium underline-offset-4 hover:underline decoration-coral">
                                Read the full deal ▸
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
